export const shapes = {
  borderRadius: {
    full: '50%',
    lg: '20px',
    md: '10px',
    sm: '5px',
    tags: '9999px',
    xm: '8px',
    xmd: '16px',
  },
  borderWidth: {
    md: '2px solid',
    none: '0px solid',
    sm: '1.5px solid',
    smpx: '1.5px',
    thin: '1px solid',
  },
} as const
